export var docElement = document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/docElement.js
// module id = 41
// module chunks = 0